export default "__VITE_ASSET__GIHB51yq__"